import POSDashboard from "../components/pos/pages/Dashboard";
import { CartProvider } from "../components/pos/contexts/cartContext";
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../components/CommonComponents/MainLayout";
import TransactionList from "../components/transaction/TransactionList";
import POSProductsTable from "../components/pos/pages/POSProductsTable";
import { POSProductsProvider } from "../components/pos/contexts/POSProductContext";
import ExpensesPage from "../components/pos/pages/ExpensesPage";
import WasteReportsPage from "../components/waste/WasteReportsPage";
import UserManualPage from "../components/manual/UserManualPage";
import { Navigate } from "react-router-dom";

// POS Routes
export const posRoutes = [
    {
        path: "/dashboard",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <CartProvider>
                        <POSDashboard />
                    </CartProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/transactions",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <TransactionList restrictToToday={true} showSummary={true} useExpensesPagination={true} />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/expenses",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <ExpensesPage />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/waste",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <WasteReportsPage mode="staff" />
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/products",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <MainLayout>
                    <POSProductsProvider>
                        <CartProvider>
                            <div className="flex w-full max-w-full min-w-0 flex-col">
                                <div className="w-full max-w-full min-w-0">
                                    <POSProductsTable />
                                </div>
                            </div>
                        </CartProvider>
                    </POSProductsProvider>
                </MainLayout>
            </ProtectedRoute>
        ),
    },
    {
        path: "/help",
        element: (
            <ProtectedRoute allowedRoles={[2]}>
                <UserManualPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/pre-release",
        element: <Navigate to="/dashboard" replace />,
    },
];
